<div class="content-page">
<header class="header">
  <div class="header-container">
    <div class="left-section">
      <button class="hamburger-btn" (click)="toggleMenu()">
        <svg fill="#1B2F3C" viewBox="0 0 24 24" width="24px" height="24px">
          <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/>
        </svg>
      </button>

      <div class="logo">
        <a routerLink="/"><img src="assets/svg/icon-logo-fc.svg" alt="PeruFC Logo" /></a>
      </div>
      <div class="separator-image">
        <img src="assets/svg/icon-separator.svg" alt="|" />
      </div>
      <nav class="nav-links">
        <a *ngFor="let cat of menuCategories"
           [routerLink]="['/lista-productos', cat.slug]"
           routerLinkActive="active">{{ cat.name }}</a>
      </nav>
    </div>
    <div class="header-actions">
      <div class="search-wrapper">
        <div class="action-icon search-icon" *ngIf="!isSearchOpen" (click)="toggleSearch(); $event.stopPropagation()">
          <img src="assets/svg/icon-search.svg" alt="Search" />
        </div>
        <div class="search-inline" *ngIf="isSearchOpen" (click)="$event.stopPropagation()">
          <input
            type="text"
            placeholder="Buscar productos..."
            [(ngModel)]="searchQuery"
            (ngModelChange)="onSearchChange()"
            autofocus
          />
          <button class="search-close" (click)="toggleSearch()">✕</button>
          <div class="search-results" *ngIf="searchResults.length > 0">
            <div class="search-item" *ngFor="let product of searchResults" (click)="selectProduct(product)">
              <img [src]="product.images[0]?.url || 'assets/images/placeholder.webp'" [alt]="product.name" />
              <div class="search-item-info">
                <span class="search-item-name">{{ product.name }}</span>
                <span class="search-item-price">S/ {{ product.finalPrice }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="separator-image">
        <img src="assets/svg/icon-separator.svg" alt="|" />
      </div>

      <ng-container *ngIf="authService.isLoggedIn(); else loginIcon">
        <div class="user-menu-wrapper">
          <div class="user-greeting" (click)="showUserMenu = !showUserMenu">
            <div class="header-avatar" *ngIf="authService.customerProfile()?.profileImageUrl">
              <img [src]="authService.customerProfile()?.profileImageUrl" alt="Perfil" />
            </div>
            <div class="header-avatar header-avatar-initials" *ngIf="!authService.customerProfile()?.profileImageUrl && authService.customerProfile()">
              {{ authService.customerProfile()?.firstName?.charAt(0) }}{{ authService.customerProfile()?.lastName?.charAt(0) }}
            </div>
            <span>Hola, {{ authService.currentUser()?.firstName }}</span>
          </div>
          <div class="user-dropdown" *ngIf="showUserMenu">
            <a routerLink="/mi-cuenta" (click)="showUserMenu = false">Mi cuenta</a>
            <a (click)="logout(); showUserMenu = false">Cerrar sesión</a>
          </div>
        </div>
      </ng-container>
      <ng-template #loginIcon>
        <div class="action-icon user-icon" (click)="showLoginModal = true">
          <img src="assets/svg/icon-avatar.svg" alt="User" />
        </div>
      </ng-template>

      <div class="action-icon cart-icon" (click)="cartService.open()">
        <img src="assets/svg/icon-shop.svg" alt="Cart" />
        <span class="cart-badge" *ngIf="cartService.items().length > 0">{{ cartService.items().length }}</span>
      </div>
    </div>
  </div>

  <!-- Sidenav -->
  <div class="sidenav-overlay" [class.open]="isMenuOpen" (click)="toggleMenu()"></div>

  <aside class="sidenav-panel" [class.open]="isMenuOpen">
    <div class="sidenav-header">
      <a routerLink="/" (click)="toggleMenu()" class="sidenav-logo">
        <img src="assets/svg/icon-logo-fc.svg" alt="PeruFC Logo" height="32px"/>
      </a>
      <button class="close-btn" (click)="toggleMenu()">
        <svg fill="#1B2F3C" viewBox="0 0 24 24" width="24px" height="24px">
          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
        </svg>
      </button>
    </div>
    <nav class="sidenav-links">
      <a *ngFor="let cat of menuCategories" (click)="goToCategory(cat)">{{ cat.name }}</a>
    </nav>
  </aside>
</header>
</div>

<!-- Login Modal -->
<div class="login-modal-overlay" *ngIf="showLoginModal || authService.showLoginModal()" (click)="showLoginModal = false; authService.showLoginModal.set(false)">
  <div class="login-modal" (click)="$event.stopPropagation()">
    <button class="login-modal-close" (click)="showLoginModal = false; authService.showLoginModal.set(false)">✕</button>
    <div class="login-modal-logo">
      <img src="assets/svg/icon-logo-fc.svg" alt="PeruFC" />
    </div>

    <div class="login-modal-tabs">
      <button [class.active]="loginView === 'login'" (click)="loginView = 'login'; loginError = ''">Iniciar sesión</button>
      <button [class.active]="loginView === 'register'" (click)="loginView = 'register'; loginError = ''">Registrarse</button>
    </div>

    <div class="login-modal-error" *ngIf="loginError">{{ loginError }}</div>

    <!-- Login -->
    <form *ngIf="loginView === 'login'" (ngSubmit)="doLogin()" class="login-modal-form">
      <input type="email" [(ngModel)]="loginForm.email" name="email" placeholder="Correo electrónico" (blur)="loginEmailTouched = true" />
      <span class="field-error" *ngIf="loginEmailTouched && loginForm.email && !isValidEmail(loginForm.email)">Correo electrónico no válido</span>
      <div class="password-field">
        <input [type]="showLoginPassword ? 'text' : 'password'" [(ngModel)]="loginForm.password" name="password" placeholder="Contraseña" />
        <button type="button" class="toggle-password" (click)="showLoginPassword = !showLoginPassword">
          <img [src]="showLoginPassword ? 'assets/svg/icon-eyes-black.svg' : 'assets/svg/icon-eyes.svg'" alt="toggle">
        </button>
      </div>
      <button type="submit" class="btn-login" [disabled]="loginLoading || !loginForm.email || !loginForm.password || !isValidEmail(loginForm.email)">
        {{ loginLoading ? 'Ingresando...' : 'Ingresar' }}
      </button>
    </form>

    <!-- Register -->
    <form *ngIf="loginView === 'register'" (ngSubmit)="doRegister()" class="login-modal-form">
      <input type="text" [(ngModel)]="registerForm.firstName" name="firstName" placeholder="Nombres" pattern="[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+" (keypress)="onlyLetters($event)" />
      <input type="text" [(ngModel)]="registerForm.lastName" name="lastName" placeholder="Apellidos" pattern="[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+" (keypress)="onlyLetters($event)" />
      <input type="text" [(ngModel)]="registerForm.dni" name="dni" placeholder="DNI" maxlength="8" (keypress)="onlyNumbers($event)" />
      <input type="email" [(ngModel)]="registerForm.email" name="regEmail" placeholder="Correo electrónico" (blur)="registerEmailTouched = true" />
      <span class="field-error" *ngIf="registerEmailTouched && registerForm.email && !isValidEmail(registerForm.email)">Correo electrónico no válido</span>
      <input type="text" [(ngModel)]="registerForm.phone" name="phone" placeholder="Celular" maxlength="9" (keypress)="onlyNumbers($event)" />
      <div class="password-field">
        <input [type]="showRegisterPassword ? 'text' : 'password'" [(ngModel)]="registerForm.password" name="password" placeholder="Contraseña" (ngModelChange)="checkPasswordCriteria()" />
        <button type="button" class="toggle-password" (click)="showRegisterPassword = !showRegisterPassword">
          <img [src]="showRegisterPassword ? 'assets/svg/icon-eyes-black.svg' : 'assets/svg/icon-eyes.svg'" alt="toggle">
        </button>
      </div>

      <div class="password-criteria">
        <span [class.valid]="pwCriteria.minLength">✓ Mínimo 8 caracteres</span>
        <span [class.valid]="pwCriteria.uppercase">✓ Una letra mayúscula</span>
        <span [class.valid]="pwCriteria.lowercase">✓ Una letra minúscula</span>
        <span [class.valid]="pwCriteria.number">✓ Un número</span>
        <span [class.valid]="pwCriteria.special">✓ Un carácter especial</span>
      </div>

      <button type="submit" class="btn-login" [disabled]="loginLoading || !isPasswordValid">
        {{ loginLoading ? 'Registrando...' : 'Crear cuenta' }}
      </button>
    </form>
  </div>
</div>

<app-register-succes #dialog></app-register-succes>